import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild, ViewChildren, QueryList, Input, Output, EventEmitter } from '@angular/core';
import { Logger } from '../../core/logger/logger.service';
import { ApiHandlerService } from '../../core/api-handlers';
import { SubSink } from 'subsink';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { SwalService } from '../../core/services/swal.service';
import { UtilityService } from '../../core/services/utility.service';
import { FlightService } from './flight.service';
import { PlatformLocation } from '@angular/common';
import { browserRefresh } from '../../../app/app.component';
import { shareReplay } from 'rxjs/operators';
import { untilDestroyed } from '../../core/services';
import { Options } from '@angular-slider/ngx-slider';

const log = new Logger('flights/FlightSearchFormComponent');
export interface LocationI {
    cityId: string;
    cityName: string;
    countryCode: string;
    status: boolean;
    source: string;
}
@Component({
    selector: 'app-flights',
    templateUrl: './flights.component.html',
    styleUrls: ['./flights.component.scss']
})
export class FlightsComponent implements OnInit, OnDestroy {

    tab : any = 'tab1';
    tab1 : any
    tab2 : any
    tab3 : any
    tab4 : any
    Clicked : boolean
    submitted: boolean = false;
    public browserRefresh: boolean;
    public flightIcon: string = "assets/images/login-images/assets/flight.png";
    public hotelIcon: string = "assets/images/login-images/assets/material-hotel.png";
    public insuranceIcon: string = "assets/images/login-images/assets/document.png";
    public plusIcon: string = "assets/images/login-images/plus.png";
    public removeIcon: string = "assets/images/login-images/remove.png";
    @ViewChild('roundtripButton', { static: true }) roundtripButton: ElementRef<HTMLElement>;
    @ViewChild('flight', { static: false }) flight: ElementRef<HTMLElement>;
    @ViewChild('hotels', { static: false }) hotels: ElementRef<HTMLElement>;
    @ViewChild('insurance', { static: false }) insurance: ElementRef<HTMLElement>;
    @ViewChild('multiButton', { static: true }) multiButton: ElementRef<HTMLElement>;
    @ViewChild('departureCity', { static: false }) departureCity: ElementRef<HTMLElement>;
    @ViewChild('destinationCity', { static: false }) destinationCity: ElementRef<HTMLElement>;
    @ViewChild('departureDate', { static: false }) departureDate: ElementRef<HTMLElement>;
    @ViewChild('returnDate', { static: false }) returnDate: ElementRef<HTMLElement>;
    @ViewChildren('mDepartureCity') mDepartureCity: QueryList<ElementRef>
    @ViewChildren('mDestinationCity') mDestinationCity: QueryList<ElementRef>
    @ViewChildren('mDepartureDate') mDepartureDate: QueryList<ElementRef>
    @ViewChild('prefferedAirline', { static: false }) prefferedAirline: ElementRef<HTMLElement>;

    @Input() searchtype;
    mobileFrom:boolean=false;
    mobileTo:boolean=false;
    @Output() callResult = new EventEmitter<any>();
    searchTabs: Array<string>;
    selectedIndex = 0;
    CabinClass: any;
    searchedList: Array<any> = Array();
    depart = false as boolean;
    isOpen = false as boolean;
    isreturnDate = false as boolean;
    exchangeCity = false;
    trendingSearches = [];
    isDisabled: boolean = false;
    onewayTab: boolean = false;
    roundtripTrab: boolean = false;
    regConfig: FormGroup;
    cityExchanged = false;
    minDate = new Date();
    minDateArr = Array(5).fill(new Date());
    maxDate;
    bsDateConf = {
        isAnimated: true,
        dateInputFormat: 'DD/MM/YYYY',
        rangeInputFormat: 'DD/MM/YYYY',
        containerClass: 'theme-blue',
        showWeekNumbers: false
    };
    fadeinn = false;
    Connectivity = false;
    airline = false;
    travellersFadeinn = false;
    travellerForm: FormGroup;
    dropDownCity: any;
    submitSessionFlightSearchKeyCheck;
    travellerCountError = false;
    infantError = false;
    airlines: any = [];
    airlineName = 'Choose Airline';
    protected subs = new SubSink();
    setMinDate: any;
    tabSubscription: any;
    activeIdString: any = "left";
    searchedAirLineList: any = {};
    maxDateChild: any;
    minDateChild: any;
    maxDateInfant: any;
    minDateInfant: any;
    mobileTraveller = false;
    webTraveller = true;
    //mobileFrom = false;
    NonStopFlights: number = 0;
    isCollapsed = false;
    priceForm: FormGroup;
    max: number = 1;
    min: number = 0;
    sliderRange: Array<number> = [0, 1];
    stepRange = [this.min, this.max];
    isLoading: boolean = false;
    minValue: number = 0;
    maxValue: number = 0;
    minPrice: any;
    maxPrice: any;
    options: Options = {
      floor: 0,
      ceil: 50000,
    };
    
    constructor(
        private fb: FormBuilder,
        public location: PlatformLocation,
        private flightService: FlightService,
        private apiHandlerService: ApiHandlerService,
        private router: Router,
        private route: ActivatedRoute,
        private swalService: SwalService,
        private utility: UtilityService,
        private cdRef: ChangeDetectorRef,
    ) {
    }

    openFromCity(): void {
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w < breakpoint) {
          this.mobileFrom = true;
        } else {
            this.mobileFrom = false;
        }
      }
      onCloseFrom():void{
        this.mobileFrom = false;
      }

      onCloseTo():void{
        this.mobileTo= false;
      }

      openToCity(): void {
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w < breakpoint) {
          this.mobileTo = true;
        } else {
            this.mobileTo = false;
        }
      }

    getIsMobile(): boolean {
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w < breakpoint) {
          return true;
        } else {
          return false;
        }
      }

      getIsdesktop(): boolean {
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w > breakpoint) {
          return true;
        } else {
          return false;
        }
      }

    ngOnInit() {
        this.setMaxMinDate();
        this.getPreferredAirlineList();
        this.flightService.flightSearchData.next([]);
        this.searchTabs = ['Roundtrip', 'Oneway', 'Multi-city'];
        this.createTravellerForm();
        this.createForm();
        if (browserRefresh == false) {
            this.onewayTab = true;
            this.roundtripTrab = true;
        }
        let data1 = sessionStorage.getItem('flightSearchData');
        data1 = JSON.parse(data1) || {};

        this.browserRefresh = browserRefresh;
        if (this.browserRefresh == false && data1.hasOwnProperty('departureCity')) {
            this.regConfig.patchValue({
                departureCity: data1['departureCity'],
                destinationCity: data1['destinationCity'],
                departureDate: new Date(data1['departureDate']),
                returnDate: data1['returnDate'] ? new Date(data1['returnDate']) : '',
                traveller: data1['traveller'],
                NonStopFlights: data1['NonStopFlights'],
            });
            // this.flightService.travellerFormFilled.subscribe(data => {
            //     this.regConfig.patchValue({
            //         traveller: data
            //     });
            //     this.travellerForm.patchValue(data);
            // })
            const tripType = data1['tripType'];
            this.flightService.tripType.next(tripType);
            switch (tripType) {
                case 'Roundtrip':
                    this.selectedIndex = 0;
                    break;
                case 'Multi-city':
                    this.selectedIndex = 2;
                    break;
                case 'Oneway':
                    this.selectedIndex = 1;
                    this.regConfig.get('returnDate').clearValidators();
                    break;
                default:
                    break;
            }
        }

        this.location.onPopState(() => {
            this.flightService.flightsCopy.next([]);
            this.flightService.flights.next([]);
            if (data1['tripType'] == 'Multi-city') {
                data1['cities'].forEach((e) => {
                    e.mDepartureDate = new Date(e.mDepartureDate);
                });
            }
            this.regConfig.patchValue({
                destinationCity: data1['destinationCity'],
                departureDate: new Date(data1['departureDate']),
                returnDate: data1['returnDate'] ? new Date(data1['returnDate']) : '',
                traveller: data1['traveller'],
                cities: data1['cities'],
                NonStopFlights: data1['NonStopFlights'],
                PreferredAirline: data1['PreferredAirlineName'],
                PreferredAirlineCode: data1['PreferredAirlines'] && data1['PreferredAirlines'][0] ? data1['PreferredAirlines'][0] : ''
            });

            // this.flightService.travellerFormFilled.subscribe(data => {
            //     this.regConfig.patchValue({
            //         traveller: data
            //     });
            //     this.travellerForm.patchValue(data);
            // })
        });

        if (!this.flightService.formFilled && (data1['tripType'] == 'Multi-city')) {
            this.selectedTrip(2);//used to clear default selected records if clicked on home icon after selecting the multicity
        }
        if (this.flightService.formFilled) {
            let data = sessionStorage.getItem('flightSearchData');
            data = JSON.parse(data);
            if (data['tripType'] == 'Multi-city') {
                data['cities'].forEach((e) => {
                    e.mDepartureDate = new Date(e.mDepartureDate);
                });
            }   
            //Added to show more than 2 multi-city added in ui
            if (data['cities'] && data['cities'].length > 2) {
                const cities = this.regConfig.get('cities') as FormArray;
                for (let i = 0; i < (data['cities'].length - 2); i++) {
                    cities.push(this.generateCities(''));
                }
            }

                this.regConfig.patchValue({
                departureCity: data['departureCity'],
                destinationCity: data['destinationCity'],
                departureDate: new Date(data['departureDate']),
                returnDate: data['returnDate'] ? new Date(data['returnDate']) : '',
                traveller: data['traveller'],
                cities: data['cities'],
                NonStopFlights: data['NonStopFlights'],
                PreferredAirline: data['PreferredAirlineName'] ? data['PreferredAirlineName'] : data['PreferredAirline']
            });
            // this.flightService.travellerFormFilled.subscribe(data => {
            //     this.regConfig.patchValue({
            //         traveller: data
            //     });
            //     this.travellerForm.patchValue(data);
            // })
            const tripType = data['tripType'];
            this.flightService.tripType.next(tripType);
            switch (tripType) {
                case 'Roundtrip':
                    this.selectedIndex = 0;
                    this.regConfig.get('returnDate').setValidators(Validators.required);
                    break;
                case 'Multi-city':
                    this.selectedIndex = 2;
                    this.regConfig.get('returnDate').setValidators(Validators.required);
                    break;
                case 'Oneway':
                    this.selectedIndex = 1;
                    this.regConfig.get('returnDate').clearValidators();
                    break;
                default:
                    break;
            }
           // this.onSubmit();
        }

        const data = { agent_id: this.utility.readStorage('b2cUser', sessionStorage)['user_id'] };
        this.subs.sink = this.apiHandlerService.apiHandler('recentSearchHistory', 'POST', '', '', data).subscribe(res => {
            if (res.Status) {
                this.trendingSearches = res.Data.RecentSearchHistory;
            } else {
            }
        });
        this.CabinClass = this.flightService.getCabinClass();
        this.subs.sink = this.apiHandlerService.apiHandler('preferredAirlines', 'POST', '', '', {}).subscribe(res => {
            if (res.Status) {
                this.airlines = res.data;
            } else {
            }
        });

        this.flightService.flightSearchData.subscribe(data => {
            if (data && data['id'] > 0) {
                this.activeIdString = 'left';
                const today = new Date()
                let tomorrow; let returnDate;
                if (new Date(data['travel_date']) > new Date(today)) {
                    let travelDate = new Date(data['travel_date']);
                    tomorrow = new Date(travelDate);
                } else {
                    tomorrow = new Date(today)
                    tomorrow.setDate(tomorrow.getDate() + 1)
                }

                if (new Date(data['return_date']) > tomorrow) {
                    let travelDate = new Date(data['return_date']);
                    returnDate = new Date(travelDate);
                } else {
                    returnDate = "";
                }
                let airlineCode;
                let airlineName;
                if (data['airlines'].includes('-')) {
                    let airline;
                    airline = data['airlines'].split('-');
                    airlineName= airline[0];
                    airlineCode=airline[1];
                }
                this.regConfig.patchValue({
                    departureCity: data['from_airport_name'],
                    destinationCity: data['to_airport_name'],
                    departureDate: tomorrow,//data['travel_date'],
                    returnDate: returnDate,
                    CabinClass: data['class'],
                    tripType: data['trip_type'],
                    NonStopFlights: data['NonStopFlights'],
                    traveller: data['traveller'] || 1,
                    PreferredAirline: airlineName ? airlineName : 'All Airline',
                    PreferredAirlineCode:airlineCode ? airlineCode: 'ALL'
                });

                // this.flightService.travellerFormFilled.subscribe(data => {
                //     this.regConfig.patchValue({
                //         traveller: data
                //     });
                //     this.travellerForm.patchValue(data);
                // })
                let tripType = data['trip_type'] == "oneWay" ? "Oneway" : "Roundtrip";
                this.toggleTripType(tripType);
                if(data['trip_type'].toLowerCase() == "oneway") {
                    this.regConfig.get('returnDate').clearValidators();
                }
                else{
                    this.regConfig.get('returnDate').setValidators(Validators.required);
                    this.regConfig.get('returnDate').updateValueAndValidity();
                }
                this.regConfig.markAsUntouched();

            } else {
            }
        })

        this.mobileTraveller = this.getIsMobile();
        window.onresize = () => {
          this.mobileTraveller = this.getIsMobile();
        };

        this.webTraveller = this.getIsdesktop();
        window.onresize = () => {
          this.webTraveller = this.getIsdesktop();
        };
        
    }

    getPreferredAirlineList(): void {
        this.apiHandlerService.apiHandler('preferredAirlines', 'POST', '', '', {})
          .pipe(
            shareReplay(1),
            untilDestroyed(this)
          )
          .subscribe((resp: any) => {
            if (resp.Status) {
              this.searchedAirLineList = resp.data;
            } else {
              this.searchedAirLineList = [];
            }
            this.cdRef.detectChanges();
          });
      }
  

    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.regConfig.controls[controlName].touched) && this.regConfig.controls[controlName].hasError(errorName));
    }

    toggleTripType(tripType) {
        switch (tripType) {
            case 'Roundtrip':
                this.selectedIndex = 0;
                break;
            case 'Multi-city':
                this.selectedIndex = 2;
                break;
            case 'Oneway':
                this.selectedIndex = 1;
                break;
            default:
                break;
        }
    }

    onSearchTypeChange(value) {
        sessionStorage.setItem('activeId', value);
        this.activeIdString = sessionStorage.getItem('activeId');
    }

    ngAfterViewInit() {
        this.tabSubscription = this.flightService.changeEmitted$.subscribe(tabvalue => {
            this.validateTabs(tabvalue);
        });
    }


    validateTabs(tabvalue) {
        if (tabvalue == 'flights') {
            this.flight && this.flight.nativeElement.click()
        }
        else if (tabvalue == 'hotels') {
            this.hotels && this.hotels.nativeElement.click()
        }
        else if (tabvalue == 'insurence') {
            this.insurance && this.insurance.nativeElement.click()
        }
    }


    openDate() {
        this.isOpen = true;
        this.Connectivity = false;
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
        this.tabSubscription.unsubscribe();
    }

    selectedTrip(i: number): void {
        this.submitted = false;
        this.flightService.tripTypeClicked = true;
        this.selectedIndex = i;
        this.regConfig.patchValue({ tripType: this.searchTabs[i] });
        if (i != 2) {
            this.regConfig.get('returnDate').clearValidators();
            if (i == 0) {
                this.regConfig.get('returnDate').setValidators(Validators.required);
            }
            if (this.regConfig.controls.departureCity.value == 'test') {
                this.regConfig.patchValue({ departureCity: '' });
            }
            if (this.regConfig.controls.destinationCity.value == 'test') {
                this.regConfig.patchValue({ destinationCity: '' });
            }
            this.regConfig.patchValue({
                departureDate: '',
                returnDate: '',
                cities: [
                    { mDepartureCity: 'DAC', mDestinationCity: 'CGP', mDepartureDate: '2022-02-25T00:00:00' },
                    { mDepartureCity: 'CGP', mDestinationCity: 'CXB', mDepartureDate: '2022-02-25T00:00:00' }
                ]
            });
            this.regConfig.markAsUntouched();
        } else {
            if (this.regConfig.controls.departureCity.value == '') {
                this.regConfig.patchValue({ departureCity: 'DAC' });
            }
            if (this.regConfig.controls.destinationCity.value == '') {
                this.regConfig.patchValue({ destinationCity: 'CGP' });
            }
            if (this.regConfig.controls.departureDate.value == '') {
                this.regConfig.patchValue({ departureDate: '2022-02-25T00:00:00' });
            }
            if (this.regConfig.controls.returnDate.value == '') {
                this.regConfig.patchValue({ returnDate: '2022-02-25T00:00:00' });
            }
             //Added to clear more than 2 cities addeed under multi-city
             const cities = this.regConfig.get('cities') as FormArray;
             if (cities.value && cities.value.length > 2) {
                 while (cities.value.length > 2) {
                     cities.removeAt(cities.length - 1);
                 }
             }
            this.regConfig.patchValue({
                cities: [
                    { mDepartureCity: 'DAC', mDestinationCity: '', mDepartureDate: '' },
                    { mDepartureCity: '', mDestinationCity: '', mDepartureDate: '' }
                ]
            });
            this.regConfig.controls.cities.markAsUntouched();
        }
    }
    get classes() {
        const cssClasses = {};
        cssClasses['bg-info'] = true;
        return cssClasses;
    }


    getSearchedList(event: any): void {
        if (event.target.id === 'departureCity') {
            this.depart = true;
        } else if (event.target.id === 'destinationCity') {
            this.depart = false;
        }
        if (event && event.target.value) {
            const text = `${event.target.value}`.trim();
            if(text && text.length>=3){
            this.apiHandlerService.apiHandler('airportList', 'POST', '', '', { text })
                .pipe(
                    shareReplay(1),
                    untilDestroyed(this)
                )
                .subscribe((resp: any) => {
                    if (resp.Status) {
                        this.searchedList = resp.data;
                    } else {
                        const msg = resp['Message'];
                        this.searchedList=[];
                    }
                    this.cdRef.detectChanges()
                });
            }
            else{
                this.searchedList=[];
            }
        }
    }

    getPreferredAirLineList(event: any): void {
        let city = `${event.name}, (${event.code})`;
        if (city) {
            this.flightService.destCountry = event;
            // this.regConfig.patchValue({ destinationCity: city });
            this.regConfig.patchValue({
                PreferredAirline: event.name,
                PreferredAirlineCode: event.code
            });
            this.prefferedAirline.nativeElement.click();
            this.searchedAirLineList.length = 0;
        }
    }


    applyTrendingSearch(ts: any) {
        this.regConfig.patchValue({
            tripType: 'Oneway', /* temp line */
            departureCity: ts.departureCity + '(' + ts.departureCityCode + ')',
            destinationCity: ts.destinationCity + '(' + ts.destinationCityCode + ')',
            // departureDate: dt
        })
    }

    submitForm(data: any) {
        this.flightService.flightsCopy.next([]);
        this.flightService.flights.next([]);
        this.callResult.emit(data);
    }


    createForm(): void {
        this.regConfig = this.fb.group({
            departureCity: ['', [Validators.required]],
            destinationCity: ['', [Validators.required]],
            departureDate: ['', [Validators.required]],
            returnDate: ['', [Validators.required]],
            tripType: 'Oneway',
            traveller: this.fb.group({
                adults: 1,
                childrens: 0,
                infants: 0,
                childDateOfBirth:this.fb.array([]),
                infantDateOfBirth:this.fb.array([])
            }),
            CabinClass: ['Economy', [Validators.required]],
            PreferredAirlines: [''],
            PreferredAirlineCode: [''],
            PreferredAirline: ['All'],
            connectivity: ['All', [Validators.required]],
            NonStopFlights:  [''],
            fromPrice:  new FormControl(''),  
            toPrice:  new FormControl(''),
            cities: this.fb.array([this.generateCities('DAC'), this.generateCities('CGP')]),
        });
        if (this.flightService.formFilled) {
            this.setTravellerForm();
        } else if (this.flightService.isDevelopment) {
            this.regConfig.patchValue({
                departureCity: 'Bangalore(BLR)',
                destinationCity: 'Chennai(MAA)',
                departureDate: new Date(),
                traveller: this.flightService.traveller
            });
            this.travellerForm.patchValue(this.flightService.traveller);
        }
    }

    setTravellerForm(){
        this.setTravellerChild();
        this.setTravellerInfant();
        this.regConfig.patchValue(this.flightService.formFilled);
        this.travellerForm.patchValue(this.flightService.formFilled.traveller);
    }

    setTravellerChild() {
        this.flightService.formFilled.traveller.childDateOfBirth = this.flightService.formFilled.traveller.childDateOfBirth.map(child => {
            const date = new Date(formatDate(new Date(child.childDateOfBirth), 'yyyy-MM-dd','en-US'));
            return { childDateOfBirth: date};
        });
        this.patchChildDateOfBirth(this.flightService.formFilled.traveller.childDateOfBirth);
        this.patchRegChildDateOfBirth(this.flightService.formFilled.traveller.childDateOfBirth);
    }

    setTravellerInfant() {
        this.flightService.formFilled.traveller.infantDateOfBirth = this.flightService.formFilled.traveller.infantDateOfBirth.map(infant => {
            const date =new Date(formatDate(infant.infantDateOfBirth, 'yyyy-MM-dd', 'en-US'));
            return { infantDateOfBirth: date };
        });
        this.patchInfantDateOfBirth(this.flightService.formFilled.traveller.infantDateOfBirth);
        this.patchRegInfantDateOfBirth(this.flightService.formFilled.traveller.infantDateOfBirth);
    }

    createTravellerForm() {
        this.travellerForm = this.fb.group({
            adults: 1,
            childrens: 0,
            infants: 0,
            childDateOfBirth:this.fb.array([]),
            infantDateOfBirth:this.fb.array([])
        });
    }

    generateCities(d: string) {
        let dDate = new Date();
        if(this.regConfig && this.regConfig.controls.tripType.value==='Multi-city'){
            return this.fb.group({
                mDepartureCity: [d, [Validators.required]],
                mDestinationCity: [d, [Validators.required]],
                mDepartureDate: ['', [Validators.required]]
            });
        }
        else{
            return this.fb.group({
                mDepartureCity: [d, [Validators.required]],
                mDestinationCity: [d, [Validators.required]],
                mDepartureDate: [dDate, [Validators.required]]
            });
        }
    }

    onSubmitTraveller() {
        this.travellersFadeinn = false;
    }

    onUpdateTraveller(travellerType: string, operation: string) {
        const adults = this.travellerForm.get('adults').value;
        const childrens = this.travellerForm.get('childrens').value;
        const infants = this.travellerForm.get('infants').value;
        const control = this.travellerForm.controls[travellerType];
        const dateOfBirth = this.travellerForm.controls['childDateOfBirth'];
        const infantDOB = this.travellerForm.controls['infantDateOfBirth'];
        let result = 0;
        let travellerCount = 0;
        if (operation === 'minus') {
            result = control.value < 1 ? control.value : control.value - 1;
        } else {
            result = control.value + 1;
        }
        if (travellerType == 'adults' || travellerType == 'childrens') {
            travellerCount = adults + childrens;
        } else {
            travellerCount = infants;
        }
        if (travellerCount > 8 && operation === 'plus') {
            this.travellerCountError = true;
            this.infantError = false;
            return false;
        }
        if ((adults <= infants && operation === 'plus' && travellerType == 'infants') || (adults <= infants && operation === 'minus' && travellerType == 'adults')) {
            this.travellerCountError = true;
            this.infantError = true;
            return false;
        }
        if (operation === 'minus') {
            result = control.value < 1 ? control.value : control.value - 1;
            if (travellerType == 'childrens' && travellerCount>1) { this.removechildDateOfBirth(dateOfBirth); }
            if (travellerType == 'infants') { this.removeInfantDateOfBirth(infantDOB); }
        } else {
            result = control.value + 1;
            if (travellerType == 'childrens' && travellerCount<=8) {  this.addChildDateOfBirth(dateOfBirth);}
            if (travellerType == 'infants' ) {  this.addInfantDateOfBirth(infantDOB);}
        }
        if (operation === 'minus' && travellerType == 'adults' && result < 1) {
            return false;
        }
        
        this.patchChildDateOfBirth(dateOfBirth);
        this.patchInfantDateOfBirth(infantDOB);
        this.travellerCountError = false;
        control.setValue(result);
        this.regConfig.patchValue({
            traveller: this.travellerForm.value
        });
    }

    patchChildDateOfBirth(dateOfBirth) {
        const regTraveller = this.regConfig.controls['traveller'] as FormArray;
        let childDateOfBirth = regTraveller.controls['childDateOfBirth'] as FormArray;
        childDateOfBirth.clear();
        for (let i = 0; i < dateOfBirth.length; i++) {
            childDateOfBirth.push(this.setChildDateOfBirth());
        }
    }

    patchRegChildDateOfBirth(dateOfBirth) {
        const childDateOfBirth = this.travellerForm.controls['childDateOfBirth'] as FormArray;
        childDateOfBirth.clear();
        for (let i = 0; i < dateOfBirth.length; i++) {
            childDateOfBirth.push(this.setChildDateOfBirth());
        }
    }

    patchInfantDateOfBirth(dateOfBirth) {
        const regTraveller = this.regConfig.controls['traveller'] as FormArray;
        let infantDateOfBirth = regTraveller.controls['infantDateOfBirth'] as FormArray;
        infantDateOfBirth.clear();
        for (let i = 0; i < dateOfBirth.length; i++) {
            infantDateOfBirth.push(this.setInfantDateOfBirth());
        }
    }

    patchRegInfantDateOfBirth(dateOfBirth) {
        const infantDateOfBirth = this.travellerForm.controls['infantDateOfBirth'] as FormArray;
        infantDateOfBirth.clear();
        for (let i = 0; i < dateOfBirth.length; i++) {
            infantDateOfBirth.push(this.setInfantDateOfBirth());
        }
    }

    addChildDateOfBirth(childDateOfBirth){
        childDateOfBirth.push(this.setChildDateOfBirth());
    }

    addInfantDateOfBirth(infantDateOfBirth){
        infantDateOfBirth.push(this.setInfantDateOfBirth());
    }

    setChildDateOfBirth() {
        console.log(this.maxDate);
        return this.fb.group({
            childDateOfBirth: new Date(formatDate(new Date(this.maxDateChild), 'yyyy-MM-dd', 'en-US'))
        });
    }

    setInfantDateOfBirth() {
        return this.fb.group({
            infantDateOfBirth: new Date(formatDate(new Date(this.maxDateInfant),  'yyyy-MM-dd', 'en-US'))
        });
    }

    removechildDateOfBirth(childDateOfBirth) {
        let length = childDateOfBirth.controls.length - 1;
        childDateOfBirth.removeAt(length);
    }

    removeInfantDateOfBirth(infantDateOfBirth){
        let length=infantDateOfBirth.controls.length-1;
        infantDateOfBirth.removeAt(length);
    }

    setSelectedDate(event, index) {
        const childAges = this.regConfig.get('traveller.childDateOfBirth') as FormArray;
        childAges.at(index).patchValue({ childDateOfBirth: new Date(formatDate(new Date(event), 'yyyy-MM-dd','en-US'))});
    }

    setInfantSelectedDate(event, index) {
        const infantAges = this.regConfig.get('traveller.infantDateOfBirth') as FormArray;
        infantAges.at(index).patchValue({ infantDateOfBirth: new Date(formatDate(new Date(event), 'yyyy-MM-dd','en-US'))});
    }




    getPrefferedAirlineList(event: any): void {
        if (event && event.target.value) {
            const name = `${event.target.value}`;
            this.apiHandlerService.apiHandler('preferredAirlines', 'POST', '', '', { name })
                .pipe(
                    shareReplay(1),
                    untilDestroyed(this)
                )
                .subscribe((resp: any) => {
                    if (resp.Status) {
                        this.searchedAirLineList = resp.data;
                    } else {
                        const msg = resp['Message'];
                        this.searchedAirLineList.length = 0;
                    }
                    this.cdRef.detectChanges()
                });
        }
    }

    onChangeCabin(cabin: string) {
        this.regConfig.patchValue({
          CabinClass: cabin
        });
    
        // Set tab based on the selected cabin
        if (cabin === 'Economy') {
          this.tab = 'tab1';
        } else if (cabin === 'Business') {
          this.tab = 'tab2';
        } else if (cabin === 'First') {
          this.tab = 'tab3';
        } else {
          this.tab = 'tab4';
        }
    
        this.fadeinn = false;
      }
    

    onChangeConnectivity(v: any) {
        this.regConfig.patchValue({
            connectivity: v
        });
        this.Connectivity = false;
    }
    onChangeAirline(i: any) {
        this.regConfig.patchValue({
            PreferredAirlines: this.airlines[i]['code']
        });
        this.airline = false;
        this.airlineName = this.airlines[i]['name'];
    }

    onDepart(event) {
        console.log(event, "??????????")
        if (event && this.selectedIndex == 0) {
            setTimeout(() => {
                this.returnDate.nativeElement.click();
                this.setMinDate = event
            }, 100)

        } else if (event && this.selectedIndex == 1) {
            setTimeout(() => {
                this.isreturnDate = false;
                this.isOpen = false;
            }, 100)
            this.travellersFadeinn = true;
        }
    }

    closeTravellers() {
        this.travellersFadeinn = false;
    }
    closeAirline() {
        this.airline = false;
        this.searchedAirLineList ? this.searchedAirLineList.length = 0 : '';
    }
    get shouldPreferedAirLineHide(): boolean {
        try {
            return !!this.searchedAirLineList.length ? true : false;
        } catch (error) {
        }
    }
    onReturn(event) {
        if (event && this.selectedIndex == 0) {
                this.travellersFadeinn = true;
        }
    }

    getCity(event: any): void {
        
        let city = `${event.AirportCity}, ${event.CountryName}, ${event.AirportName}(${event.AirportCode})`;
        if (city) {
            if (event.inputFor === 'depart') {
                this.mobileFrom=false;
                this.flightService.originCountry = event;
                this.regConfig.patchValue({ departureCity: event.AirportCode });
                this.destinationCity.nativeElement.focus();
            } else {
                this.mobileTo=false;
                this.flightService.destCountry = event;
                this.regConfig.patchValue({ destinationCity: event.AirportCode });
                this.departureDate.nativeElement.click();
            }
            this.searchedList.length = 0;
        }
        this.cdRef.detectChanges();
    }

    get shouldiHide(): boolean {
        try {
            return !!this.searchedList.length ? true : false;
        } catch (error) {
        }
    }

    get f() {
        return this.regConfig.controls;
    }

    shouldiHideDynamic(index): boolean {
        if (index === 1)
            return true;
        else
            return false;
    }

    shouldRemoveCity(index): boolean {
        if (index === 0 || index === 1)
            return false;
        else
            return true;
    }



    setCurrentInput(t) {
        this.dropDownCity = t;
    }

    isCurrentInput(t) {
        return this.dropDownCity == t;
    }

    exchangeCityFn() {
        this.cityExchanged = !this.cityExchanged;
        const destinationCity = JSON.parse(JSON.stringify(this.regConfig.controls.destinationCity.value));
        const departureCity = JSON.parse(JSON.stringify(this.regConfig.controls.departureCity.value));
        this.regConfig.patchValue({ departureCity: destinationCity });
        this.regConfig.patchValue({ destinationCity: departureCity });
    }

    getDynamicCity(event: any): void {
        let city = `${event.AirportCity}(${event.AirportCode})`;
        if (city) {
            const mDesCtArr = this.mDestinationCity.toArray();
            const mDepDtArr = this.mDepartureDate.toArray();
            const inputFor = event.inputFor.split('_');
            if (inputFor[0] == 'mDepartureCity') {
                mDesCtArr[inputFor[1]].nativeElement.focus();
                this.regConfig.controls['cities']['controls'][inputFor[1]].patchValue({ mDepartureCity: event.AirportCode });
            } else {
                mDepDtArr[inputFor[1]].nativeElement.click();
                this.regConfig.controls['cities']['controls'][inputFor[1]].patchValue({ mDestinationCity: event.AirportCode });
                if (mDepDtArr[+inputFor[1] + 1]) {
                    this.regConfig.controls['cities']['controls'][+inputFor[1] + 1].patchValue({ mDepartureCity: event.AirportCode });
                }
            }
            this.searchedList.length = 0;
        }
    }

    addCity(): void {
        const cities = this.regConfig.get('cities') as FormArray;
        if (cities.length < 5) {
            cities.push(this.generateCities(''));
        }
    }

    removeCity(i: number): void {
        const cities = this.regConfig.get('cities') as FormArray;
        if (cities.length > 1) {
            cities.removeAt(i);
        }
    }

    mUpdateNextDepDt(i: number) {
        if (this.minDateArr[i + 1]) {
            this.minDateArr[i + 1] = new Date(this.regConfig.controls['cities']['controls'][i]['controls']['mDepartureDate'].value);
        }
        const mDepCtArr = this.mDestinationCity.toArray();
        if (mDepCtArr[i + 1]) {
            mDepCtArr[i + 1].nativeElement.focus();
        }
    }

    onSubmit() {
        this.submitted = true;
        if (this.regConfig.invalid) {
            return;
        }
        if(this.regConfig.controls.destinationCity.value==this.regConfig.controls.departureCity.value || this.regConfig.get('cities').value[0].mDepartureCity == this.regConfig.get('cities').value[0].mDeCity ){
            this.swalService.alert.oops('From and To city can not be the same. Please select different city!');
            return;
        }
        if(this.regConfig.controls.destinationCity.value==this.regConfig.controls.departureCity.value || this.regConfig.get('cities').value[0].mDepartureCity == this.regConfig.get('cities').value[0].mDeCity ){
            this.swalService.alert.oops('From and To city can not be the same. Please select different city!');
            return;
        }
        if (this.regConfig.value.PreferredAirlineCode === "ALL") {
            this.regConfig.controls.PreferredAirlineCode.setValue('')
        }
        
        this.submitSessionFlightSearchKeyCheck = true;
        this.flightService.formFilled = {}
        this.flightService.tripTypeClicked = false;
        this.regConfig.patchValue({
            fromPrice: this.minValue || 1, // Set the minimum price
            toPrice: this.maxValue || 0    // Set the maximum price
        });
        if (this.selectedIndex == 0) {
            this.regConfig.controls.tripType.setValue('Roundtrip')
        }
        else if (this.selectedIndex == 1) {
            this.regConfig.controls.tripType.setValue('Oneway')
        } else if (this.selectedIndex == 2) {
            this.regConfig.controls.tripType.setValue('Multi-city')
        }
        let dDate = formatDate(this.regConfig.value.departureDate, 'yyyy-MM-dd', 'en-US');
        this.regConfig.value.departureDate = dDate + "T00:00:00";
        if (this.regConfig.value.returnDate.length || this.regConfig.value.returnDate) {
            let rDate = formatDate(this.regConfig.value.returnDate, 'yyyy-MM-dd', 'en-US');
            this.regConfig.value.returnDate = rDate + "T00:00:00";
        } else {
            this.regConfig.value.returnDate = "";
        }
        this.regConfig.value.NonStopFlights = this.NonStopFlights;
        this.flightService.formFilled = this.regConfig.value;
        sessionStorage.setItem('flightSearchData', JSON.stringify(this.regConfig.value));
        sessionStorage.setItem('submitSessionFlightSearchKeyCheck', 'true');
        setTimeout(() => {
            this.isreturnDate = false;
            this.isOpen = false;
            this.travellersFadeinn = false;
        }, 100)
        if (this.router.url == "/" || (this.router.url).startsWith("/?returnUrl")) {
            this.router.navigate(["flight-result"]);
        } else {
            this.flightService.isCollapsed.next(true);
            const pattern = /\(([^)]+)\)/;
            let Segments = [];
            let JourneyType = "OneWay";
            if (this.selectedIndex == 2) {
                JourneyType = "multicity";
                this.regConfig.controls.cities.value.forEach((e) => {
                    const Origin = e.mDepartureCity;
                    const Destination = e.mDestinationCity;
                    const DepartureDate = formatDate(e.mDepartureDate, 'yyyy-MM-dd', 'en-US');
                    Segments.push({
                        Origin: Origin,
                        Destination:
                            Destination,
                        DepartureDate: DepartureDate + "T00:00:00",
                        // CabinClassReturn: this.regConfig.controls.CabinClass.value,
                        // CabinClassOnward: this.regConfig.controls.CabinClass.value
                        CabinClass: this.regConfig.controls.CabinClass.value
                    });
                });
            } else {
                const Origin = this.regConfig.value.departureCity
                const Destination = this.regConfig.value.destinationCity
                Segments.push({
                    Origin: Origin,
                    Destination: Destination,
                    CabinClassReturn: this.regConfig.controls.CabinClass.value,
                    CabinClassOnward: this.regConfig.controls.CabinClass.value
                });
                if (this.selectedIndex == 1) {
                    const dt = this.regConfig.value.departureDate;
                    const DepartureDate = formatDate(dt, 'yyyy-MM-dd', 'en-US');
                    Segments[0]["DepartureDate"] = DepartureDate + "T00:00:00";
                    Segments[0]["CabinClass"] = this.regConfig.controls.CabinClass.value;//added for one way
                } else {
                    JourneyType = "Return";
                    const dt = this.regConfig.controls.departureDate.value;
                    const rd = this.regConfig.controls.returnDate.value
                    const DepartureDate = formatDate(dt, 'yyyy-MM-dd', 'en-US');
                    const ReturnDate = formatDate(rd, 'yyyy-MM-dd', 'en-US');
                    Segments[0]["DepartureDate"] = DepartureDate + "T00:00:00";
                    Segments[0]["ReturnDate"] = ReturnDate + "T00:00:00";
                }
            }
            const formData = {
                booking_source: "ZBAPINO00002",
                AdultCount: JSON.stringify(this.regConfig.get('traveller.adults').value ? this.regConfig.get('traveller.adults').value : 1),
                ChildCount: JSON.stringify(this.regConfig.get('traveller.childrens').value ? this.regConfig.get('traveller.childrens').value : 0),
                InfantCount: JSON.stringify(this.regConfig.get('traveller.infants').value ? this.regConfig.get('traveller.infants').value : 0),
                PreferredAirlines: this.regConfig.get('PreferredAirline').value.toLowerCase() == 'all' 
                ? [] 
                : [this.regConfig.get('PreferredAirline').value || ''],
              
              PreferredAirlineName: this.regConfig.get('PreferredAirline').value.toLowerCase() == 'all' 
                ? [] 
                : [this.regConfig.get('PreferredAirline').value || []],
              
                JourneyType,
                Segments,
                NonStopFlights: this.NonStopFlights,
                childDOB:this.regConfig.get('traveller.childDateOfBirth').value,
                infantDOB:this.regConfig.get('traveller.infantDateOfBirth').value,
                fromPrice: this.minValue || 1,    // Use price range values
                toPrice: this.maxValue || 0,
            };
            this.flightService.travellerFormFilled.next({});
            this.flightService.travellerFormFilled.next(this.regConfig.controls.traveller.value);
            this.submitForm(formData);
        }
    }

    getControl(): FormArray {
        return this.travellerForm.controls['childDateOfBirth'] as FormArray
    }

    getInfantControl(): FormArray {
        return this.travellerForm.controls['infantDateOfBirth'] as FormArray
    }
      setMaxMinDate(){
        this.maxDateChild = this.addYearsToDate(-2, 0, 0);
        this.minDateChild = this.addYearsToDate(-12, 0, 0);
        this.maxDateInfant = new Date();
        this.minDateInfant = this.addYearsToDate(-2, 0, 1);
    }

    addYearsToDate(y: number, m: number, n: number) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        const c = new Date(year + y, month + m, day + n);
        return c;
    }

    getMaxMinValues() {
        this.subs.sink = this.flightService.minPrice.subscribe(min => {
            this.subs.sink = this.flightService.maxPrice.subscribe(max => {
                this.min = Math.floor(min);
                this.max = Math.ceil(max) + 1;
                this.cdRef.detectChanges();
                console.log(this.sliderRange);
                this.priceForm.patchValue({
                    min: this.min,
                    max: this.max,
                }, { emitEvent: false });
                this.isLoading = false;
                if (this.max > this.min)
                    this.sliderRange = [this.min, this.max];
                this.cdRef.detectChanges();
            });
        });
        this.cdRef.detectChanges();
    }

    createPriceForm(): void {
        this.priceForm = this.fb.group({
            min: new FormControl(this.min),
            max: new FormControl(this.max)
        })
    }

    onSliderChange(event) {
        this.priceForm.patchValue({
            min: event[0],
            max: event[1],
        }, { emitEvent: false });
        this.flightService.myValue.next(event[1]);
        this.flightService.myValueStart.next(event[0]);
        this.flightService.changeSlider();
        this.cdRef.detectChanges();
    }

    rangeChanged(r: any) {
        console.log("range...",r)
        this.flightService.myValue.next(r[1]);
        this.flightService.myValueStart.next(r[0]);
        this.flightService.changeSlider();
        this.cdRef.detectChanges();
    }

    valueChange(minVal){
        this.flightService.myValueStart.next(minVal);
        this.flightService.changeSlider();
        this.cdRef.detectChanges();
    }
    highValueChange(maxVal){
        this.flightService.myValue.next(maxVal);
        this.flightService.changeSlider();
        this.cdRef.detectChanges();
    }

    onClick(check){
        //    console.log(check);
            if(check==1){
              this.tab = 'tab1';
            }else if(check==2){
              this.tab = 'tab2';
            }else if(check==3){
              this.tab = 'tab3';
            }else{
                this.tab = 'tab4';
              }    
          
        }

        updateNonStopFlights(checked: boolean) {
            this.NonStopFlights = checked ? 1 : 0; 
            console.log("  this.NonStopFlights",  this.NonStopFlights)
          }
}
